<template>
    <div class="home-container" v-if="isMobile">
        <div class="image-area">
            <!-- <img src="../assets/logo.png" alt=""> -->
            <img src="favicon.png" alt="">
        </div>
        <!-- <p class="ready-words">点击按钮进入测评</p> -->
        <div class="userinfo">
            <div>
                <p>账号：</p>
                <input class="usermsg" type="text" placeholder="请输入账号" v-model="user">
            </div>
            <div>
                <p>密码：</p>
                <input class="usermsg" type="password" placeholder="请输入密码" v-model="pasd">
            </div>
            <!-- <div>
                <p>性别：</p>
              <select class="usermsg" type="radio" placeholder="请选择性别" v-model="gender">
                <option value="male">男</option>
                <option value="female">女</option>
              </select>
            </div> -->
        </div>
        <el-button type="warning" @click="start">登陆</el-button>
        <!--        <el-button type="warning" @click="debug">Skip</el-button>-->
    </div>
    <div class="not-found" v-else>
        <div>
            <div>
                <svg xmlns="http://www.w3.org/2000/svg" class="fill-current text-red-300 h-16 w-16" viewBox="0 0 20 20"
                    fill="currentColor" style="color: rgba(252, 165, 165, 1);width: 12rem;height: 12rem;">
                    <path fill-rule="evenodd"
                        d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                        clip-rule="evenodd"></path>
                </svg>
            </div>
            <p>平台检测到您正在使用计算机浏览此页面，</p>
            <p>本入口主要面向移动端，建议您从微信或者手机浏览器访问，</p>
            <p>或者下载面向计算机的客户端软件。</p>
        </div>
    </div>
</template>

<script>
import api from '@/api/index'
export default {
    name: "Home",
    data() {
        return {
            user: '',
            pasd: '',
            sj_id: 1708667428,
            isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
        }
    },
    methods: {
        debug() {
            this.$router.push('/question')
        },
        start() {
            var that = this;
            if (that.user === '') {
                alert('请输入账号')
                return;
            }
            if (that.pasd === '') {
                alert('请输入密码')
                return;
            }

            this.$http.post('https://xl.880802.club/index/getlogin', {
                user: that.user,
                pasd: that.pasd,
                sj_id: that.sj_id
            }, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).catch(error => {
                alert('连接超时，请联系管理员')
            }).then(function (res) {
                console.log(res.data.msg);
                var code = res.data.code;
                if (code === 0) {
                    alert(res.data.msg)
                    return;
                }


                that.$store.commit('recordUid', res.data.userid);
                that.$store.commit('deleteRecord');
                // console.log(that.$store.state);
                that.$router.push('/faceDetect/' + that.sj_id)
                // that.$router.push('/question/' + that.sj_id)
                // that.$router.push('/testScore/' + that.sj_id)
                // if(that.user=='test1'){
                //     that.$router.push('/testScore/' + that.sj_id)
                // }else{
                //     that.$router.push('/faceDetect/' + that.sj_id)
                // }
            })
        }
    },
    created() {
        // var that = this;
        // var sj_id = that.$route.params.sj_id;
        // this.sj_id = sj_id;
    },
}
</script>

<style scoped>
.home-container {
    text-align: center;
}

.image-area {
    height: 15rem;
}

.image-area img {
    height: 80%;
    margin: 3rem 0;
}

.ready-words {
    color: #909399;
    font-size: 2rem;
    margin: 2rem 0;
}

.userinfo {
    margin: 2rem 0;
    font-size: 1.5rem;
}

.usermsg {
    height: 3rem;
    border-radius: 0.6rem;
    width: 50%;
    color: rgba(0, 0, 0, 0.8);
    font-size: 1.5rem;
    text-align: left;
}

.not-found {
    text-align: center;
    margin-top: 50px;
    font-size: 24px;
}
</style>